var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from "react";
import { styled } from '../theme/ThemeHelpers';
var FullScreenClickableDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: fixed;\n    z-index: ", ";\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100%;\n"], ["\n    position: fixed;\n    z-index: ", ";\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100%;\n"])), function (props) { return props.zIndex ? props.zIndex : 10000; });
var InvisibleDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: none;\n    position: fixed;\n    z-index: ", ";\n    top: 0;\n    left: 0;\n    width: 0;\n    height: 0;\n"], ["\n    display: none;\n    position: fixed;\n    z-index: ", ";\n    top: 0;\n    left: 0;\n    width: 0;\n    height: 0;\n"])), function (props) { return props.zIndex ? props.zIndex : 10000; });
var close = function (props) { return function (ev) {
    props.onClick(ev);
    var div = ev.target;
    if (div) {
        div.hidden = true;
        var next = document.elementFromPoint(ev.clientX, ev.clientY);
        if (next && next.focus) {
            next.focus();
        }
        if (next && next.click) {
            next.click();
        }
        div.hidden = false;
    }
}; };
var FullScreenClickable = React.memo(function (props) {
    if (props.show)
        return React.createElement(FullScreenClickableDiv, { onClick: close(props), zIndex: props.zIndex });
    else
        return React.createElement(InvisibleDiv, { zIndex: props.zIndex });
});
export default FullScreenClickable;
var templateObject_1, templateObject_2;
//# sourceMappingURL=FullScreenClickable.js.map